import withAsyncRouteLoading from "UIComponents/AsyncRouteLoadingHoc";
import {
  setSubChildId,
  prefixCurriculumName,
} from "Administrator/modules/AdministratorModule";
import { getSelectedCurriculumId } from "modules/CommonSelectors";
import { OVERALL_SETUP } from "Constants/stringConstants";
export default store => ({
  path: "overall-setup",
  component: withAsyncRouteLoading(
    () =>
      Promise.all([
        import(/* webpackChunkName: "admin-academicSetup" */ "./components"),
      ]).then(([importedModule0]) => {
        const component = importedModule0.default;
        return component;
      })
    //.catch(err => {
    //   throw err;
    // })
  ),
  onEnter() {
    const state = store.getState();
    const curriculumProgramId = getSelectedCurriculumId(state);
    const childId = store.dispatch(
      prefixCurriculumName({
        childId: OVERALL_SETUP,
        curriculumProgramId,
      })
    );
    store.dispatch(setSubChildId(childId));
  },
  onLeave() {
    store.dispatch(setSubChildId(""));
  },
});
